import React from 'react';
import { MailIcon } from 'lucide-react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/catio';
export function Footer() {
  return <footer id="site-footer" className="bg-ink py-12 text-ivory" data-id="element-57" data-mp="3ggtx2ezk5d3n">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-58" data-mp="32onj8zjvni7d">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-59" data-mp="32m1ch24t96q7">
          <div data-id="element-60" data-mp="36n3d9nedlqua">
            <p className="wordmark text-[1.5rem]" data-id="element-61" data-mp="3uf0lz5mj42r6">
              Catio <span className="text-ember" data-id="element-62" data-mp="3ufjvbxy45itl">Ready</span>
              <sup className="ml-0.5 text-[0.45em]" data-id="element-63" data-mp="3991omvfnkca">™</sup>
            </p>
            <p className="mt-2 text-[0.9rem] text-white/60" data-id="element-64" data-mp="36czunggsbik">{PRODUCT.descriptor}</p>
          </div>

          <div data-id="element-65" data-mp="3lgos8uqd8oui">
            <p className="label-tech text-white/50" data-id="element-66" data-mp="3qd6rxg6u9wzz">
              Support
            </p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-2 inline-flex min-h-[44px] items-center gap-2 text-[0.92rem] text-ivory/80 transition-colors duration-150 ease-out hover:text-ember-light" data-id="element-67" data-mp="29z6x2jmuoxjl">
              <MailIcon className="h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-68" data-mp="3labr7utqu4pu" />
              <span className="break-all" data-id="element-69" data-mp="3gb8vx23kfcv2">{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-ivory/15 pt-6 text-[0.8rem] text-ivory/50" data-id="element-70" data-mp="3v8rh5uh1b7xr">
          <p data-id="element-71" data-mp="3q8div458jccx">Digital DIY plan collection. Digital files may not be redistributed or resold.</p>
          <p className="mt-2" data-id="element-72" data-mp="828n46lrs59o">© 2026 CATIO READY™. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}